import React from 'react'
// import clsx from 'clsx'
import { Caption } from '@maggioli-design-system/react'
import { useNavigate } from 'react-router-dom'
import AIBadge from './AIBadge'

const description: string = "Questo contenuto è generato tramite strumenti di Intelligenza Artificiale e potrebbe non essere sempre esatto e fedelmente rappresentativo del testo. Considera di verificare le informazioni che ritieni importanti.";

const AIGenerated = ({ className = "", ...restProps }) => {

    const router = useNavigate()

    const onClick = () => {
        router("/ai-policy");
    }

    return <button
        aria-label={`Contenuto generato dall'intelligenza artificiale. ${description} Consulta la policy AI.`}
        className={className + ' cursor-pointer inline-flex items-center gap-2 bg-adjust-tone-19 rounded-full px-4 pl-1.5 py-1.5 border-0'}
        onClick={() => onClick()}
        title={description}
        type="button">
        <div aria-hidden="true" className="bg-adjust-tone-04 rounded-full inline-flex items-center justify-center w-6 h-6 text-adjust-tone">
            <AIBadge className="h-[22px]"/>
        </div>
        <Caption>
            AI Generated
        </Caption>
    </button>
}
export default AIGenerated
